import gql from 'graphql-tag';

export type HubCounterListAddress = {
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
};

export type HubCounterListUser = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};

export type HubCounterListDropPoint = {
  id: string;
  isActive: boolean;
  locationName: string;
  createdAt: string;
  address?: HubCounterListAddress | null;
  user: HubCounterListUser;
  accessPoint?: { id: string; status: string } | null;
};

export type HubCounterListRecord = {
  id: string;
  hubCounterID?: string | null;
  amazonAccessPointId?: string | null;
  loginClaim?: string | null;
  status: string;
  isActive: boolean;
  amazonVerified?: boolean | null;
  amazonVerifiedAt?: string | null;
  lastFeedId?: string | null;
  lastFeedStatus?: string | null;
  lastDeactivationTimestamp?: string | null;
  deactivatedUntil?: string | null;
  rejectionReason?: string | null;
  rejectionTimestamp?: string | null;
  createdAt: string;
  updatedAt: string;
  dropPoint: HubCounterListDropPoint;
};

export type HubCounterListItem = {
  displayState: string;
  sessionStatus?: string | null;
  sessionVerified: boolean;
  emailChangedAfterWaitlist?: boolean | null;
  createFeedSubmitted?: boolean | null;
  hubCounter: HubCounterListRecord;
};

export type HubCountersQuery = {
  hubCounters: HubCounterListItem[];
};

export const GET_HUB_COUNTERS = gql`
  query GET_HUB_COUNTERS($status: [HubCounterStatus!]!, $sortBy: HubCounterSortField, $sortOrder: SortOrder, $loginRequired: Boolean) {
    hubCounters(status: $status, sortBy: $sortBy, sortOrder: $sortOrder, loginRequired: $loginRequired) {
      displayState
      sessionStatus
      sessionVerified
      emailChangedAfterWaitlist
      createFeedSubmitted
      hubCounter {
        id
        hubCounterID
        amazonAccessPointId
        loginClaim
        status
        isActive
        amazonVerified
        amazonVerifiedAt
        lastFeedId
        lastFeedStatus
        lastDeactivationTimestamp
        deactivatedUntil
        rejectionReason
        rejectionTimestamp
        createdAt
        updatedAt
        dropPoint {
          id
          isActive
          locationName
          createdAt
          address {
            street
            houseNumber
            postalCode
            city
          }
          user {
            id
            firstName
            lastName
            email
          }
          accessPoint {
            id
            status
          }
        }
      }
    }
  }
`;
